/**
 * Kiosk-mode hardening: no context menu, no text selection, no zoom, auto-hiding cursor.
 * Returns a cleanup function.
 */
const CURSOR_IDLE_MS = 3000;

export function installKioskHardening(): () => void {
  const root = document.documentElement;
  const opts: AddEventListenerOptions = { passive: false };

  const prevent = (e: Event) => e.preventDefault();
  const preventUnlessEditable = (e: Event) => {
    const t = e.target;
    if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement) return;
    e.preventDefault();
  };

  const onWheel = (e: WheelEvent) => {
    if (e.ctrlKey) e.preventDefault(); // trackpad pinch / ctrl+wheel zoom
  };

  const onKeyDown = (e: KeyboardEvent) => {
    if ((e.ctrlKey || e.metaKey) && ['+', '-', '=', '_', '0'].includes(e.key)) e.preventDefault();
  };

  const onTouchMove = (e: TouchEvent) => {
    if (e.touches.length > 1) e.preventDefault();
  };

  let idleTimer: number | undefined;
  const onActivity = () => {
    root.classList.remove('cursor-hidden');
    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(() => root.classList.add('cursor-hidden'), CURSOR_IDLE_MS);
  };

  document.addEventListener('contextmenu', prevent, opts);
  document.addEventListener('selectstart', preventUnlessEditable, opts);
  document.addEventListener('dragstart', prevent, opts);
  document.addEventListener('gesturestart', prevent, opts);
  document.addEventListener('wheel', onWheel, opts);
  document.addEventListener('keydown', onKeyDown, opts);
  document.addEventListener('touchmove', onTouchMove, opts);
  document.addEventListener('pointermove', onActivity, { passive: true });
  document.addEventListener('pointerdown', onActivity, { passive: true });
  onActivity();

  return () => {
    window.clearTimeout(idleTimer);
    document.removeEventListener('contextmenu', prevent, opts);
    document.removeEventListener('selectstart', preventUnlessEditable, opts);
    document.removeEventListener('dragstart', prevent, opts);
    document.removeEventListener('gesturestart', prevent, opts);
    document.removeEventListener('wheel', onWheel, opts);
    document.removeEventListener('keydown', onKeyDown, opts);
    document.removeEventListener('touchmove', onTouchMove, opts);
    document.removeEventListener('pointermove', onActivity);
    document.removeEventListener('pointerdown', onActivity);
    root.classList.remove('cursor-hidden');
  };
}
